import React, {createContext, useReducer} from 'react'

export const SET_DEVICE_CONNECTION_DATA = 'SET_DEVICE_CONNECTION_DATA'
export const UPDATE_CHANGE_DEVICE_CONNECTION_DATA =
  'UPDATE_CHANGE_DEVICE_CONNECTION_DATA'
export const SET_SELECTED_DEVICE_CONNECTION_DATA =
  'SET_SELECTED_DEVICE_CONNECTION_DATA'
export const SET_SHOW_HIDE_DEVICE_CONNECTION_POPUP =
  'SET_SHOW_HIDE_DEVICE_CONNECTION_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_DEVICE_CONNECTION_DATA: {
      return {...data, data: payload.data}
    }
    case UPDATE_CHANGE_DEVICE_CONNECTION_DATA: {
      let tempData = [...data.data.results]
      tempData[payload.data.index] = payload.data
      return {
        ...data,
        data: {...data.data, results: tempData},
        showDeviceConnFormPopup: false,
        selectedObject: {},
      }
    }
    case SET_SELECTED_DEVICE_CONNECTION_DATA: {
      return {
        ...data,
        selectedObject: payload.data,
        showDeviceConnFormPopup: true,
      }
    }
    case SET_SHOW_HIDE_DEVICE_CONNECTION_POPUP: {
      if (payload.data) {
        return {...data, showDeviceConnFormPopup: payload.data}
      }
      return {
        ...data,
        showDeviceConnFormPopup: payload.data,
        selectedObject: {},
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: {results: [], pagination: {}},
  selectedObject: {},
  showDeviceConnFormPopup: false,
}

const DeviceConnectionStore = ({children}) => {
  const [state, dispatch] = useReducer(Reducer, initialState)
  return (
    <DeviceConnectionContext.Provider value={[state, dispatch]}>
      {children}
    </DeviceConnectionContext.Provider>
  )
}

export const DeviceConnectionContext = createContext(initialState)
export default DeviceConnectionStore
